import { createJSONStorage, devtools, persist } from "zustand/middleware";
import i18next from "i18next";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

interface ILocalizationStore {
  language: string | null;
  changeLanguage: (lang: string) => void;
  initLanguage: (path: string, queryLang?: string) => void;
}

export const useLocalizationStore = createWithEqualityFn<ILocalizationStore>()(
  devtools(
    persist(
      (set, get) => ({
        language: null,
        changeLanguage: (language: string) => {
          i18next.changeLanguage(language);
          set({ language });
        },
        initLanguage: (path, queryLang) => {
          const storedLang = get().language?.toLowerCase();
          const urlLang = path.split("/")[1]?.toLowerCase(); // Например, 'ru' из '/ru/page'
          const validLangs = ["en", "ru"]; // Список ваших языков

          let initialLang = "en"; // Дефолтный язык
          if (queryLang && validLangs.includes(queryLang)) {
            initialLang = queryLang; // Приоритет для query-параметра
          } else if (urlLang && validLangs.includes(urlLang)) {
            initialLang = urlLang; // Затем язык из URL
          } else if (storedLang && validLangs.includes(storedLang)) {
            initialLang = storedLang; // Затем localStorage
          }

          i18next.changeLanguage(initialLang);
          set({ language: initialLang });
        },
      }),
      {
        name: "localization-storage",
        storage: createJSONStorage(() => localStorage),
        partialize: (state) => ({ language: state.language }),
      },
    ),
    { name: "Localization Store" },
  ),
  shallow,
);
